import '../../styles/pageloader.css';

/**
 * Full-page centred spinner shown while data is loading.
 * Usage: <PageLoader />
 */
export default function PageLoader() {
  return (
    <div className="pl-wrap">
      <div className="pl-spinner" />
      <div className="pl-text">Loading…</div>
    </div>
  );
}
